import React, { useEffect, useRef, useState } from "react";
import { Link as RouterLink, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Box, CircularProgress, Link, Typography } from "@mui/material";
import { magic_login_api } from "../DAL/Login/Login";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";

const DEFAULT_NEXT = "/dashboard";

/** Only same-app relative paths — never protocol-relative or auth pages. */
const safeNextPath = (raw) => {
  const value = String(raw || "").trim();
  if (!value.startsWith("/") || value.startsWith("//")) return DEFAULT_NEXT;
  if (value.startsWith("/login") || value.startsWith("/magic-login")) {
    return DEFAULT_NEXT;
  }
  return value;
};

export default function MagicLogin() {
  const params = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState("");
  const startedRef = useRef(false);
  const { handleUserInfo, START_SOCKET_FORCEFULLY } = useContentSetting();

  const handleMagicLogin = async () => {
    const result = await magic_login_api({ token: params.token });
    if (result?.code === 200 && result?.token && result?.member) {
      localStorage.setItem(`user_data`, JSON.stringify(result.member));
      localStorage.setItem(`user_data_new`, JSON.stringify(result.member));
      localStorage.setItem("token", result.token);
      if (result.member.target_weight) {
        localStorage.setItem("unit_added", true);
      }
      if (result.member.is_guest === true) {
        // Guests never see the member onboarding video.
        localStorage.setItem("is_seen_video", "Yes");
      } else if (localStorage.getItem("is_seen_video") !== "Yes") {
        localStorage.setItem("is_seen_video", "No");
      }
      handleUserInfo(result.member);
      START_SOCKET_FORCEFULLY(result.member._id);
      navigate(safeNextPath(searchParams.get("next")), { replace: true });
      return;
    }
    setErrorMessage(
      result?.message || "This login link is invalid or has expired",
    );
  };

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;
    handleMagicLogin();
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        px: 2,
        gap: 2,
      }}
    >
      {errorMessage ? (
        <>
          <Typography variant="h5">We couldn't open your journey</Typography>
          <Typography sx={{ color: "text.secondary", maxWidth: 420 }}>
            {errorMessage}
          </Typography>
          <Link component={RouterLink} to="/login" underline="hover">
            Go to login
          </Link>
        </>
      ) : (
        <>
          <CircularProgress color="primary" />
          <Typography sx={{ color: "text.secondary" }}>
            Opening your journey…
          </Typography>
        </>
      )}
    </Box>
  );
}
